import React, { Fragment } from 'react';
import NavbarS3 from '../../components/NavbarS3/NavbarS3';
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.svg'
import PricingSection from '../../components/PricingSection/PricingSection';
import MessengerChatButton from '../../components/Messenger/ChatSection';
import { useTranslation } from 'react-i18next';



const ProductGroupPage = (props) => {
    const { t } = useTranslation();


    return (
        <Fragment>
            <NavbarS3 hclass={'wpo-site-header wpo-header-style-2'} Logo={Logo} />
            <PageTitle pageTitle={t('ProductPlan.title')} pagesub={t('products')} />
            <PricingSection hclass={'wpo-about-area-s2 section-padding'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
            <MessengerChatButton />
        </Fragment>
    )
};
export default ProductGroupPage;



